"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Reports/components/RangePicker.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Form = require('web/components/Form');
var _range = require('../range');

const CUSTOM = 'custom'








const RangePicker = ({ choice, limits, onChange }) => {
  // Today, as of this render, so a page left open past midnight allows the new day.
  const today = new Date().toDateString()
  const futureDays = _react.useMemo.call(void 0, () => ({ after: new Date(today) }), [today])
  // Custom dates being picked; the report keeps its range until they're valid.
  const [custom, setCustom] = _react.useState(
    'start' in choice ? choice : null,
  )

  const options = _react.useMemo.call(void 0, 
    () => {
      const days = limits
        ? [1, 7, limits.DefaultRangeDays, limits.MaxRangeDays].filter(d => d <= limits.MaxRangeDays)
        : [1, 'days' in choice ? choice.days : 1]
      return [
        ...[...new Set(days)].sort((a, b) => a - b).map(d => ({
          value: String(d),
          label: d === 1 ? 'Today' : `Last ${d} days`,
        })),
        { value: CUSTOM, label: 'Custom' },
      ]
    },
    [limits, choice],
  )

  const pickCustom = _react.useCallback.call(void 0, 
    (next) => {
      setCustom(next)
      const days = _range.countDays.call(void 0, next.start, next.end)
      if (days >= 1 && (!limits || days <= limits.MaxRangeDays)) onChange(next)
    },
    [limits, onChange],
  )

  const onSelect = _react.useCallback.call(void 0, 
    (v) => {
      if (v !== CUSTOM) {
        setCustom(null)
        onChange({ days: Number(v) })
        return
      }
      setCustom({ start: _range.firstDayOf.call(void 0, choice), end: _range.lastDayOf.call(void 0, choice) })
    },
    [choice, onChange],
  )
  const onStart = _react.useCallback.call(void 0, (start) => custom && pickCustom({ ...custom, start }), [custom, pickCustom])
  const onEnd = _react.useCallback.call(void 0, (end) => custom && pickCustom({ ...custom, end }), [custom, pickCustom])

  const customDays = custom ? _range.countDays.call(void 0, custom.start, custom.end) : 0
  const error = !custom ? null
    : customDays < 1 ? 'Pick an end date on or after the start date.'
      : limits && customDays > limits.MaxRangeDays ? `Pick a range of ${limits.MaxRangeDays} days or less.`
        : null

  return (
    _react2.default.createElement('div', { className: "settings--org-reports--range", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
      , _react2.default.createElement(_Form.SimpleSelect, {
        'aria-label': "Date range" ,
        className: "settings--org-reports--select",
        value: custom ? CUSTOM : 'days' in choice ? String(choice.days) : CUSTOM,
        options: options,
        onChange: onSelect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
      )
      ,  custom && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_Form.DateInput, {
            ariaLabel: "Start date" ,
            className: "settings--org-reports--date",
            value: custom.start,
            disabledDays: futureDays,
            onChange: onStart, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
          )
          , _react2.default.createElement(_Form.DateInput, {
            ariaLabel: "End date" ,
            className: "settings--org-reports--date",
            value: custom.end,
            disabledDays: futureDays,
            onChange: onEnd,
            hasError: !!error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
          )
        )
      )
      ,  error && (
        _react2.default.createElement('p', { className: "settings--org-reports--range-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}},  error )
      )
    )
  )
}

exports. default = RangePicker
